module.exports = __webpack_public_path__ + "static/media/top-nfts-11.d829b0c5.jpg";